<template>
  <div>
    <b-modal
      ref="my-modal"
      no-close-on-backdrop
      size="lg"
      :title="formTitle"
      centered
      @ok="submit"
      @cancel="hideModal"
    >
      <b-tabs v-model="tab" content-class="mt-3" valiue>
        <b-tab title="General" active value="tab-1">
          <form-wrapper :validator="$v.customer">
            <b-row>
              <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <div class="form-group">
                  <label>Name</label>
                  <BaseInput v-model="customer.name" name="name" />
                </div>
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <div class="form-group">
                  <label>Phone</label>
                  <BaseInput
                    v-model="customer.phone"
                    name="phone"
                    type="number"
                  />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label>Customer Type</label>
                <DropDown
                  v-model="customer.customer_type_id"
                  :options="GetCustomerTypes"
                />
              </b-col>
              <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label>Customer Group</label>
                <DropDown
                  v-model="customer.customer_group_id"
                  :options="GetCustomerGroups"
                />
              </b-col>

              <b-col
                class="form-group"
                cols="12"
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
              >
                <label>Remarks</label>

                <BaseInput
                  v-model="customer.remarks"
                  name="remarks"
                  type="textarea"
                />
              </b-col>
            </b-row>
          </form-wrapper>
        </b-tab>
        <b-tab title="Addresses" value="tab-2">
          <form-wrapper :validator="$v.customer">
            <b-row>
              <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <Address ref="address" v-model="customer.addresses" />
              </b-col>
            </b-row>
          </form-wrapper>
        </b-tab>
        <!-- <b-tab title="Contacts" value="tab-3">
          <form-wrapper>
            <b-row>
              <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <Contact v-model="customer.contacts" />
              </b-col>
            </b-row>
          </form-wrapper>
        </b-tab> -->
      </b-tabs>

      <div slot="modal-footer">
        <b-button
          v-if="tab == 1"
          variant="secondary"
          type="submit"
          class="btn btn-primary"
          size="sm"
          @click="hideModal"
        >
          Cancel
        </b-button>
        <b-button
          v-if="tab != 1"
          variant="primary"
          type="submit"
          size="sm"
          @click="checkValidations"
        >
          Next
        </b-button>
        <b-button
          variant="primary"
          class="ml-2"
          type="submit"
          size="sm"
          @click="submit"
        >
          {{ this.for == "create" ? "Create" : "Edit" }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
// Components
import BaseInput from "@/components/base/Input";
import DropDown from "@/components/base/DropDown";
import Address from "@/components/sections/Address/Index";
import Contact from "@/components/sections/Contact/Index";

// Models
import { CustomerModel, CustomerDecorator } from "@/models/CustomerModel";
import { ContactModel, ContactDecorator } from "@/models/CustomerModel";
import { AddressModel, AddressDecorator } from "@/models/AddressModel";
// Vuelidate validations
import {
  required,
  minLength,
  maxLength,
  alpha,
} from "vuelidate/lib/validators";

import { mapGetters } from "vuex";

export default {
  name: "CustomerForm",
  components: {
    BaseInput,
    DropDown,
    Address,
    Contact,
  },
  props: {
    selectedCustomer: {
      type: Object,
      default: {},
    },
    for: {
      type: String,
      default: "create",
    },
  },

  data: () => ({
    // dialog: false
    tab: 0,
    customer: { ...CustomerModel },
    customerTypes: [
      { id: 1, name: "Type 01" },
      { id: 2, name: "Type 02" },
      { id: 3, name: "Type 03" },
    ],
    customerGroups: [
      { id: 1, name: "Type 01" },
      { id: 2, name: "Type 02" },
      { id: 3, name: "Type 03" },
    ],
  }),
  methods: {
    fetchUser() {
      const customerId = this.selectedCustomer.id;
      this.$store.dispatch("customer/fetchUser", customerId).then((res) => {
        res.data.contacts = res.data.contact;
        delete res.data.contact;
        this.customer = new CustomerDecorator(res.data).toData();
      });
    },
    checkValidations() {
      if (this.isValid()) this.tab += 1;
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant,
        solid: true,
      });
    },
    initialize() {
      // Initialized the customer object
      this.customer = { ...CustomerModel };
      this.customer.addresses = [];
      this.customer.contacts = [];
      this.$v.$reset();
    },
    addAdditionalAddress() {
      this.customer.addresses.push({ ...AddressModel });
    },
    RemoveAddress(index) {
      this.customer.addresses.splice(index, 1);
    },
    addAdditionalPhone() {
      this.customer.contacts.push({ ...ContactModel });
    },
    RemovePhone(index) {
      this.customer.contacts.splice(index, 1);
    },
    isValid() {
      this.$v.$touch();

      let status = false;

      status = !this.$v.$invalid;
      // this.$emit('valid', status)

      if (status) {
        return true;
      }
      return false;
    },
    showModal() {
      if (this.for == "edit") {
        this.fetchUser();
      }
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    submit(e) {
      if (this.for == "create") {
        this.createUser(e);
      } else this.updateUser(e);
    },
    createUser(e = null) {
      if (e != null) {
        e.preventDefault();
      }
      if (this.isValid()) {
        var customer = new CustomerDecorator(this.customer).toRequest();
        
        this.$store
          .dispatch(
            "customer/CreateCustomer",
            new CustomerDecorator(this.customer).toRequest()
          )
          .then((res) => {
            this.customer = { ...CustomerModel };
            this.showToast("Customer Created Successfully", "success");
            this.hideModal();
          })
          .catch((err) => {});
      }
    },

    updateUser(e = null) {
      if (e != null) {
        e.preventDefault();
      }
      if (this.isValid()) {
        this.customer.contacts[0].phone = this.customer.phone;

        this.$store
          .dispatch("customer/UpdateCustomer", {
            id: this.selectedCustomer.id,
            payload: new CustomerDecorator(this.customer).toRequest(),
          })
          .then((res) => {
            this.customer = { ...CustomerModel };
            this.showToast("Customer Details Updated ", "success");
            this.hideModal();
          })
          .catch((err) => {});
      }
    },
  },
  computed: {
    ...mapGetters("customer", ["GetCustomerTypes", "GetCustomerGroups"]),
    formTitle() {
      if (this.for == "create") {
        return "Create Customer";
      }
      return "Edit Customer";
    },
  },
  mounted() {
    this.initialize();
  },
  validations: {
    customer: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      phone: {
        required,
        minLength: minLength(7),
        maxLength: maxLength(15),
      },
      maximum_credit_amount: { required },
      payment_team: { required },
      customer_type_id: { required },
      customer_group_id: { required },
      remarks: {},
      is_allow_exceed: { required },
    },
  },
};
</script>
<style scoped>
.block {
  margin-bottom: unset !important;
}

.block-content {
  padding: 4px 10px 1px !important;
}

.product_area {
  height: 110px;
  width: 100%;
  border: 1px solid #d8d7d7;
  border-radius: 15px;
  padding: 8px;
}

.product_name {
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  color: #162947;
  height: 32px;
}

.product_image .image,
.product_image img {
  background-size: contain;
  height: 60px;
  width: 100%;
  border-radius: 13px;
  float: right;
}

input[type="checkbox"].custom_toggle {
  font-size: 14px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 2.5em;
  height: 1em;
  background: #ddd;
  border-radius: 3em;
  position: relative;
  cursor: pointer;
  outline: none;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

input[type="checkbox"].custom_toggle:checked {
  background: #0ebeff;
}

input[type="checkbox"].custom_toggle:after {
  position: absolute;
  content: "";
  width: 1em;
  height: 1em;
  border-radius: 50%;
  background: #fff;
  -webkit-box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.3);
  -webkit-transform: scale(0.7);
  transform: scale(0.7);
  left: 0;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}

input[type="checkbox"].custom_toggle:checked:after {
  left: calc(100% - 1em);
}
</style>
